__turbopack_context__.v({
  "actionMenuItemStyle": "x8OyDW_actionMenuItemStyle",
  "actionMenuItemStyleBlock": "x8OyDW_actionMenuItemStyleBlock",
  "actionMenuItemStyleCenter": "x8OyDW_actionMenuItemStyleCenter",
  "actionMenuItemStyleMinimal": "x8OyDW_actionMenuItemStyleMinimal",
  "mobileOverlay": "x8OyDW_mobileOverlay",
  "mobileWrapper": "x8OyDW_mobileWrapper",
  "wrapper": "x8OyDW_wrapper",
});
